/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Scenario_C_DescInputs */

const en_pol_scenario_c_desc = /** @type {(inputs: Pol_Scenario_C_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An API key you own, billed to your provider account.`)
};

const id_pol_scenario_c_desc = /** @type {(inputs: Pol_Scenario_C_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API milik kamu, ditagih ke akun penyediamu.`)
};

/**
* | output |
* | --- |
* | "An API key you own, billed to your provider account." |
*
* @param {Pol_Scenario_C_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_scenario_c_desc = /** @type {((inputs?: Pol_Scenario_C_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Scenario_C_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_scenario_c_desc(inputs)
	return en_pol_scenario_c_desc(inputs)
});